export const environment = {
  production: true,
  apiUrl: 'https://api-website.zad-erp.net/api',
  firebase: {
    // TODO: Replace these with your actual Firebase project configuration
    apiKey: "YOUR_API_KEY",
    authDomain: "your-project-id.firebaseapp.com",
    projectId: "your-project-id",
    storageBucket: "your-project-id.appspot.com",
    messagingSenderId: "YOUR_SENDER_ID",
    appId: "YOUR_APP_ID"
  }
};
